import styled from "styled-components/macro";

export const ContainerMetadata = styled.div``;

export const TitleRangePrice = styled.h5``;
